import FooterBottom from "./footer-bottom";
export default FooterBottom
